import { render, staticRenderFns } from "./statement_ticket.vue?vue&type=template&id=65cb4dba&scoped=true&"
import script from "./statement_ticket.vue?vue&type=script&lang=js&"
export * from "./statement_ticket.vue?vue&type=script&lang=js&"
import style0 from "./statement_ticket.vue?vue&type=style&index=0&id=65cb4dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb4dba",
  null
  
)

export default component.exports